export default (
  state,
  {
    payload: {
      id,
      colourWayId,
      variantId,
      isVariantLowInStock,
      isVariantInStock,
      imageUrl,
      price,
      fulfilment,
      discount
    }
  }
) => ({
  ...state,
  items: [
    ...state.items.map(item =>
      item.id === id
        ? {
            ...item,
            indicatives: {
              ...item.indicatives,
              variantId,
              isVariantLowInStock,
              isVariantInStock,
              ...(colourWayId && {
                colourWayId
              }),
              ...(imageUrl && { imageUrl }),
              ...(price && { price }),
              ...fulfilment,
              discount
            }
          }
        : item
    )
  ]
});
